module.exports = __webpack_public_path__ + "assets/img/mygift-back.aae33854.png";